export default __webpack_public_path__ + "static/media/profile.33a94898.PNG";